import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { QueryParam } from '@bingads-webui-react/scope-service';
import {
  siteMapPropType,
  findSiteMap,
} from '@bingads-webui-campaign-react/with-site-map';
import { PmaxAssetDetailsSummaryBar } from '@bingads-webui-campaign-react/summary-bar';

const isLeafNode = item => item && item.children.length === 0 && item.selected === true;

export const Loader = (props) => {
  const {
    isVisible,
    siteMap,
    updateAvailability,
    scope,
    ...others
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const selectedChild = selectedParent && findSiteMap([selectedParent], isLeafNode);

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent) && !_.isEmpty(selectedParent.id) && scope.values.assetGroupId);
  });

  return isVisible ? (
    <PmaxAssetDetailsSummaryBar
      selectedParent={selectedParent}
      selectedChild={selectedChild}
      siteMap={siteMap}
      {...others}
    />
  ) : null;
};

Loader.propTypes = {
  isVisible: PropTypes.bool,
  siteMap: siteMapPropType.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  updateAvailability: PropTypes.func,
};

Loader.defaultProps = {
  isVisible: false,
  updateAvailability: _.noop,
};

export const PmaxAssetDetailsSummaryBarLoader = React.memo(Loader);
